module.exports = __webpack_public_path__ + "img/etherscan-logo.3f649f29.svg";